import { useId } from 'react'
import IconContainer from '@/components/IconContainer'

export default function IconColorMenu(props) {
  const id = useId()
  return (
    <IconContainer
      {...props}
      width="20"
      height="20"
      ariaLabel="Menu Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path
        fill={`url(#${id})`}
        d="M18.3086 2.46875C18.8264 2.46875 19.2461 2.88848 19.2461 3.40625C19.2461 3.92402 18.8264 4.34375 18.3086 4.34375H2.18752C1.66975 4.34375 1.25001 3.92402 1.25001 3.40625C1.25001 2.88848 1.66975 2.46875 2.18751 2.46875H18.3086ZM18.3086 15.6566C18.8264 15.6566 19.2461 16.0763 19.2461 16.5941C19.2461 17.1119 18.8264 17.5316 18.3086 17.5316H2.18751C1.66975 17.5316 1.25001 17.1119 1.25001 16.5941C1.25001 16.0763 1.66975 15.6566 2.18751 15.6566H18.3086ZM19.2456 10C19.2456 9.48226 18.8259 9.06253 18.3081 9.06253H2.18779C1.67002 9.06253 1.25029 9.48226 1.25029 10C1.25029 10.5178 1.67002 10.9375 2.18779 10.9375H18.3081C18.8259 10.9375 19.2456 10.5178 19.2456 10Z"
      />
      <defs>
        <linearGradient
          id={id}
          x1="19.2461"
          y1="11.2106"
          x2="1.25005"
          y2="11.2343"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0057FF" />
          <stop offset="1" stopColor="#0082CC" />
        </linearGradient>
      </defs>
    </IconContainer>
  )
}
